import { render, staticRenderFns } from "./ReclamationSummary.vue?vue&type=template&id=5df5a640"
import script from "./ReclamationSummary.vue?vue&type=script&lang=js"
export * from "./ReclamationSummary.vue?vue&type=script&lang=js"
import style0 from "./ReclamationSummary.vue?vue&type=style&index=0&id=5df5a640&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports